// import { useAuth } from '@praxis/component-auth'
import { Card } from '@enterprise-ui/canvas-ui-react'
import { useSelector } from 'react-redux'
import { getUserInfo, userIsInSomeRole } from '../../../resources/commonUtills'
import NavigateToMaintainScreen from './NavigateToMaintain'
import DownloadItemData from './DownloadItemData'
import ExportVisibleColumns from './ExportVisibleColumns'
import RedirectToPipeline from './RedirectToPipeline'
import UpdateTaskStatus from './UpdateTaskStatus'
import AddComments from './AddComments'
import DownloadDQIssues from './DownloadDQIssues'
import CopyTcins from './CopyTcins'
import ValidateItemData from './ValidateItemData'
import DeleteItems from './DeleteItems'
import MMBActions from './MMBAction'
import CasepackAction from './CasepackAction'
import PresentationAttributes from './PresentationAttributes'
import VOPActions from './VOPAction'
// import FixedAssortmentAction from './FixedAssortment.js'
// import CrossOver from './CrossOver'
// import Unpublished from './Unpublished'
// import ClearItems from './ClearItems'
import constants from '../../../constants/constants'
import {
  filterTCINs,
  filterWithMultipleMatches,
} from '../../../resources/searchUtills'

export const Actionbar = (props) => {
  // const auth = useAuth()
  const {
    selectedItems,
    onOpenDownloadModal,
    onExportVisibleColumns,
    exportInProgress,
  } = props
  const selectedTcins = selectedItems?.map((item) => item.tcin, [])
  // const { searchActionButtons } = props?.actionControls

  const getUserProfile = useSelector((state) => {
    return getUserInfo(state)
  })
  const canUserDelete = userIsInSomeRole(getUserProfile?.roles, [
    constants.USER_ROLES.ADMIN,
    constants.USER_ROLES.SUPPORT,
    constants.USER_ROLES.MAINTAINER,
  ])

  // Is Item Validator Role
  const isItemValidator = userIsInSomeRole(getUserProfile?.roles, [
    constants.USER_ROLES.VALIDATOR,
  ])

  // Is Vendor Role
  const isVendor = userIsInSomeRole(getUserProfile?.roles, [
    constants.USER_ROLES.VENDOR,
  ])

  // Only ADMIN, MAINTAINER, SUPPORT are allowed to use action bar "Download item data"
  const isInternalUserForBulk = userIsInSomeRole(
    getUserProfile?.roles,
    constants.USER_ROLE_GROUPINGS.INTERNAL_USER_BULK,
  )

  // Is Casepack Role
  const isCasepackRole = userIsInSomeRole(getUserProfile?.itemRoles, [
    constants.USER_ROLES.CASEBACKUSER,
  ])

  // Is VOP Role
  const isVopRole = userIsInSomeRole(getUserProfile?.itemRoles, [
    constants.USER_ROLES.VOPUSER,
  ])

  const isPresentationRole = userIsInSomeRole(
    [...(getUserProfile?.roles ?? []), ...(getUserProfile?.itemRoles ?? [])],
    [
      constants.USER_ROLES.PRESENTATIONUSER,
      constants.USER_ROLES.MAINTAINER,
      constants.USER_ROLES.ADMIN,
    ],
  )

  // IsMMBItems
  const isMMB = filterTCINs(
    filterWithMultipleMatches(selectedItems, { isMMBItem: true }),
  )
  return (
    <>
      {selectedItems?.length > 0 && (
        <Card className="bg-default-interactive hc-mt-md footer-actions-section">
          <div className="action-buttons hc-pa-normal action-buttons-left-section">
            {/* <span className="hc-clr-contrast-weak">
              {selectedTcins?.length} Items Selected
            </span> */}
            {!isItemValidator && (
              <NavigateToMaintainScreen selectedItems={selectedItems} />
            )}
            {isInternalUserForBulk && (
              <DownloadItemData onOpenDownloadModal={onOpenDownloadModal} />
            )}
            {isInternalUserForBulk && (
              <ExportVisibleColumns
                onExportSelectedItems={onExportVisibleColumns}
                isLoading={exportInProgress}
              />
            )}
            {!isItemValidator && !isVendor && (
              <RedirectToPipeline selectedTcins={selectedTcins} />
            )}
            {!isItemValidator && (
              <UpdateTaskStatus selectedTcins={selectedTcins} />
            )}
            {!isItemValidator && <AddComments selectedTcins={selectedTcins} />}
            {!isItemValidator && (
              <DownloadDQIssues selectedTcins={selectedTcins} />
            )}
            <CopyTcins selectedTcins={selectedTcins} />
            {isItemValidator && (
              <ValidateItemData selectedItems={selectedItems} />
            )}
            {canUserDelete && <DeleteItems selectedItems={selectedItems} />}
            {isMMB.length !== 0 && (
              <>
                <span className="hc-clr-contrast-weak">|</span>
                <MMBActions
                  selectedTcins={selectedTcins}
                  selectedItems={props?.selectedItems}
                />
              </>
            )}
          </div>
          <div className="action-buttons hc-pa-normal action-buttons-middle-section">
            {!isItemValidator && (isVopRole || isVendor) && (
              <VOPActions selectedItems={selectedItems} />
            )}

            {!isItemValidator && (isCasepackRole || isVendor) && (
              <CasepackAction selectedItems={selectedItems} />
            )}
            {!isItemValidator && (isPresentationRole || isVendor) && (
              <PresentationAttributes selectedItems={selectedItems} />
            )}
            {/* TODO The Fixed Assortment development is going on */}
            {/* <FixedAssortmentAction selectedItems={selectedItems} /> */}
          </div>
        </Card>
      )}
    </>
  )
}
